export const iconFontAwesomePoliticalRepublican = (
	<i className="fa-solid fa-republican"></i>
);
